import { Modal, Space, Row, Col } from 'antd';
import { useContext } from 'react';
import { TradesContext } from '../../contexts/tradeProcessContext';
import SelectedDateCard from './SelectedDateCard';
import { formatLabel } from '../../util/Common';

const ConfirmModal = ({
  title,
  description,
  onOk,
  onCancel,
  confirmLoading,
  okText,
  cancelText,
}) => {
  const { formValues, openModal } = useContext(TradesContext);

  return (
    <Modal
      title={title}
      open={openModal}
      onOk={onOk}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      cancelButtonProps={{ disabled: confirmLoading }}
    >
      <Space
        direction="vertical"
        style={{
          width: '100%',
        }}
      >
        <p>{description}</p>
        <Row gutter={[16, 16]} style={{ minWidth: '100%' }}>
          {Object.entries(formValues).map(([key, value]) => (
            key === 'notes' ? null : <Col key={key} xs={24} sm={12} lg={8}>
              <SelectedDateCard label={formatLabel(key)} value={value} />
            </Col>
          ))}
        </Row>
      </Space>
    </Modal>
  );
};

export default ConfirmModal;
